import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { distinctUntilChanged, filter, Observable, of } from 'rxjs';
import { View } from '../../../../shared/store/view/types';
import { FormService } from '../../../../shared/store/form/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubHeaderService } from '../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../shared/store/view/views.service';
import { ChequeRemittanceService } from '../../../../shared/store/cheque-remittance/cheque-remittance.service';
import { ChequeRemittanceModel } from '../../../../shared/store/cheque-remittance/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { formatDate } from '../../../../shared/helper/datehelper';
import { AccountService } from '../../../../shared/store/account/account.service';
import {
  AccountModel,
  PaymentEntryModel,
} from '../../../../shared/store/accounting/types';
import { DocumentTypeModel } from '../../../../shared/store/document-type/types';
import { ModalContentComponent } from '../../../../shared/components/modal-content/modal-content.component';
import { ActionButton } from '../../../../shared/components/modal-content/action-button';
import { toFirstLetterLower } from '../../../../shared/helper/stringhelper';
import { SourceEnum } from '../../../../shared/store/typeahead/types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../shared/service/modal.service';
import { SearchService } from '../../../../shared/store/search/search.service';
import { take } from 'rxjs/operators';
import { SelectedRows } from '../../../../shared/store/search/types';
import { DateTime } from 'luxon';
import { TimeZoneService } from '../../../../common/time-zone/time-zone.service';
import { CashControlModel } from '../../../../shared/store/cash-control/types';
import { MAX_DATE_MASK_SAFE_GUARD } from '../../../../shared/constants/date.constants';
import { ModalComponentKey } from 'src/app/shared/service/modal-component';

@UntilDestroy()
@Component({
  selector: 'app-cheque-remittance-form-content',
  standalone: false,
  templateUrl: './cheque-remittance-form-content.component.html',
  styleUrl: './cheque-remittance-form-content.component.scss',
})
export class ChequeRemittanceFormContentComponent implements OnInit, OnDestroy {
  view$: Observable<View>;
  chequeRemittanceForm: FormGroup;
  chequeRemittanceModel$: Observable<ChequeRemittanceModel>;
  createChequeRemittanceInstance$: Observable<ChequeRemittanceModel>;

  paymentEntryModels: PaymentEntryModel[];
  paymentEntryModelIds: number[] = [];
  paymentEntryModelsCount: number = 0;
  paymentEntryModelsTotalAmount: number = 0;

  isEditMode: boolean = false;
  chequeRemittanceId: string;
  bankAccountDomain: string = 'ContactId=';

  accountModel$: Observable<AccountModel>;

  maxDateMaskSafeGuard: string = MAX_DATE_MASK_SAFE_GUARD;

  constructor(
    private readonly formService: FormService,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
    private readonly chequeRemittanceService: ChequeRemittanceService,
    private readonly accountService: AccountService,
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
    private readonly searchService: SearchService,
    private readonly timeZoneService: TimeZoneService,
  ) {
    this.view$ = this.viewService.getViews.value$;
    this.chequeRemittanceModel$ = this.chequeRemittanceService.getById.value$;
    this.createChequeRemittanceInstance$ =
      this.chequeRemittanceService.createInstance.value$;
    this.accountModel$ = this.accountService.getById.value$;
  }

  ngOnInit(): void {
    //init
    this.searchService.setSelectedRows({
      data: [],
      isTotalRowCountSelected: false,
    });

    //Déclaration du formulaire
    this.chequeRemittanceForm = this.formBuilder.group({
      salesTeamAccountId: [undefined, [Validators.required]],
      bankAccountId: [undefined, [Validators.required]],
      deliveryDate: [undefined, [Validators.required]],
    });

    //Récupération de l'id via la route pour déterminer si mode Edit (true) ou Create (false)
    //x this.chequeRemittanceId = this.route.snapshot.params['id'];
    this.isEditMode = !!this.chequeRemittanceId;

    //On appelle les API en fonction du mode
    if (this.isEditMode) {
      //x this.chequeRemittanceService.getById.call(this.chequeRemittanceId);
    } else {
      this.chequeRemittanceService.createInstance.call();
    }

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        //x if (x == 'chequeRemittanceCreate' || x == 'chequeRemittanceUpdate')
        if (x == 'chequeRemittanceCreate') this.onSubmit();
        if (x == 'chequeRemittanceList') {
          this.formService.clear();
          this.router.navigate(['Finance/ChequeRemittances/']);
        }
        if (x == 'chequeRemittanceDetails') {
          this.formService.clear();
          this.router.navigate([
            '/Finance/ChequeRemittances/Details',
            this.chequeRemittanceId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);

        if (!this.isEditMode)
          this.breadcrumbService.set(
            '@chequeRemittanceCreate',
            x.breadcrumbCreate,
          );
      });

    //x this.chequeRemittanceModel$
    //   .pipe(
    //     filter((x) => this.isEditMode),
    //     filter((x) => !!x),
    //     take(1),
    //   )
    //   .subscribe((x) => {
    //     this.breadcrumbService.set('@chequeRemittanceEdit', x.name);
    //     this.chequeRemittanceForm.patchValue({});
    //   });

    this.createChequeRemittanceInstance$
      .pipe(
        filter((x) => !this.isEditMode),
        filter((x) => !!x),
        untilDestroyed(this),
      )
      .subscribe((x) => {
        const localDeliveryDate = new Date(
          this.timeZoneService.fromUtcToLocal(
            x.deliveryDate,
            `yyyy-MM-dd'T'HH:mm:ss.SSS`,
          ),
        );
        this.chequeRemittanceForm?.patchValue({
          deliveryDate: formatDate(localDeliveryDate, 'ToInverseSqlDate'),
        });
      });

    //When the salesTeamAccountId changes, we call the existing Account to get the contactId
    this.chequeRemittanceForm
      .get('salesTeamAccountId')
      ?.valueChanges?.pipe(distinctUntilChanged(), untilDestroyed(this))
      ?.subscribe((x) => {
        if (!!x) {
          this.accountService.getById.call(x.toString());
        } else {
          this.accountService.getById.reset();
        }
      });

    this.accountModel$.pipe(untilDestroyed(this)).subscribe((x) => {
      this.chequeRemittanceForm.get('bankAccountId')?.setValue(undefined);
      if (x?.contactId) {
        this.bankAccountDomain = 'ContactId=' + x.contactId;
      } else {
        this.bankAccountDomain = 'ContactId=';
      }
    });
  }

  openModalChoiceAccountMovesCheques() {
    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.ChequeRemittanceFormCheques,
      );
    modalRef.componentInstance.title = 'CHEQUE_REMITTANCE_TITLE_SELECT_CHEQUES';
    modalRef.componentInstance.cancelButton = true;
    modalRef.componentInstance.buttons = [
      <ActionButton>{
        actionName: toFirstLetterLower('chequeRemittanceSelectCheques'),
      },
    ];
    modalRef.componentInstance.inputParams = {
      source: SourceEnum.Modal,
    };

    modalRef.result
      .then((id) => {
        if (id >= 0) {
          this.searchService
            .getSelectedRows()
            .pipe(take(1))
            .subscribe((selectedRows) => {
              // if (selectedRows.data.length == 0) return;

              this.paymentEntryModels = selectedRows.data;
              this.paymentEntryModelIds = this.paymentEntryModels.map(
                (item) => item.accountMoveId,
              );
              this.paymentEntryModelsCount = this.paymentEntryModels.length;
              this.paymentEntryModelsTotalAmount =
                this.paymentEntryModels.reduce(
                  (previousValue, currentValue) =>
                    previousValue + currentValue.amount,
                  0,
                );
            });
          modalRef.close();
        }
      })
      .finally(() => {
        //avoid error on cancel
      });
  }

  onSubmit() {
    if (this.chequeRemittanceForm.invalid) {
      this.chequeRemittanceForm.markAllAsTouched();
      this.formService.setEntityErrors('CHEQUE_REMITTANCE');
      this.formService.countErrors(this.chequeRemittanceForm, true);
      return;
    }

    const dateDelivery = new Date(
      this.chequeRemittanceForm.value.deliveryDate!,
    );

    const chequeRemittanceModel: ChequeRemittanceModel = {
      id: this.chequeRemittanceId ? +this.chequeRemittanceId : 0,
      salesTeamAccountId: this.chequeRemittanceForm.value.salesTeamAccountId!,
      bankAccountId: this.chequeRemittanceForm.value.bankAccountId!,
      deliveryDate: DateTime.fromJSDate(dateDelivery).toUTC(),
      accountMoveIds: this.paymentEntryModelIds,

      // createdBySalesPersonId:
      //   this.chequeRemittanceForm.value.createdBySalesPersonId!,
      // creationDate: this.chequeRemittanceForm.value.creationDate!,
      // name: this.chequeRemittanceForm.value.name!,

      //Others
      amount: 0,
      bankAccountIban: '',
      createdBySalesPersonName: '',
      salesTeamAccountName: '',
      actions: [],
      accountMoves: [],
      createdBySalesPersonId: 0,
      creationDate: DateTime.fromJSDate(new Date()).toUTC(),
      name: '',
      accountMovesCount: 0,
    };

    let result$: Observable<ChequeRemittanceModel>;
    if (this.isEditMode) {
      // result$ = this.chequeRemittanceService.update.call(chequeRemittanceModel);
      result$ = of();
    } else {
      result$ = this.chequeRemittanceService.add.call(chequeRemittanceModel);
    }

    result$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((result) => {
        this.formService.clear();
        this.router.navigate(['/Finance/ChequeRemittances/Details', result.id]);
      });
  }

  ngOnDestroy(): void {
    this.chequeRemittanceService.add.reset();
    //x this.chequeRemittanceService.update.reset();

    if (this.isEditMode) {
      //x this.chequeRemittanceService.getById.reset();
    } else {
      this.chequeRemittanceService.createInstance.reset();
    }

    this.accountService.getById.reset();

    // this.breadcrumbService.set('@chequeRemittanceEdit', ' ');
    this.breadcrumbService.set('@chequeRemittanceCreate', ' ');

    this.searchService.setSelectedRows({
      data: [],
      isTotalRowCountSelected: false,
    });

    this.modalService.dismissAll(false);
  }
}
